"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CloudStorageFolders = exports.zodFileSchema = exports.CreateFileSchema = exports.FileSchema = exports.FileType = void 0;
const Joi = __importStar(require("joi"));
const zod_1 = require("zod");
var FileType;
(function (FileType) {
    FileType["pdf"] = "application/pdf";
    FileType["jpg"] = "image/jpeg";
    FileType["xls"] = "application/vnd.ms-excel";
    FileType["xlsx"] = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    FileType["doc"] = "application/msword";
    FileType["docx"] = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
    FileType["png"] = "image/png";
    FileType["gif"] = "image/gif";
    FileType["txt"] = "text/plain";
    FileType["ppt"] = "application/vnd.ms-powerpoint";
    FileType["pptx"] = "application/vnd.openxmlformats-officedocument.presentationml.presentation";
    FileType["csv"] = "text/csv";
    FileType["rar"] = "application/x-rar-compressed";
    FileType["zip"] = "application/zip";
    FileType["jpeg"] = "image/jpeg";
    FileType["odt"] = "application/vnd.oasis.opendocument.text";
    FileType["rtf"] = "application/rtf";
})(FileType || (exports.FileType = FileType = {}));
exports.FileSchema = Joi.object({
    fileName: Joi.string().allow(null),
    fileId: Joi.string().uuid().required(),
    contentType: Joi.string().required(),
});
exports.CreateFileSchema = Joi.object({
    content: Joi.string().base64().required(),
    contentType: Joi.string().required(),
    name: Joi.string(),
});
exports.zodFileSchema = zod_1.z.object({
    fileName: zod_1.z.string(),
    fileId: zod_1.z.string(),
    contentType: zod_1.z.string(),
});
var CloudStorageFolders;
(function (CloudStorageFolders) {
    CloudStorageFolders["TRANSACTION_IMPORT"] = "transaction-imports";
})(CloudStorageFolders || (exports.CloudStorageFolders = CloudStorageFolders = {}));
//# sourceMappingURL=index.js.map